import { PropsWithChildren, ReactElement } from "react";
import styles from "./GlobalNavigationItemContent.module.less";

export type GlobalNavigationItemContentProps = {
	icon?: ReactElement;
};

export const GlobalNavigationItemContent = (props: PropsWithChildren<GlobalNavigationItemContentProps>): ReactElement => {
	const {
		icon,
		children
	} = props;

	return (
		<div className={styles.container}>
			<div
				className={styles.icon}
			>
				{icon}
			</div>
			{children}
		</div>
	);
};

GlobalNavigationItemContent.displayName = "GlobalNavigationItemContent";